import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { formatFleetFuelTSh } from '../../utils/fleetFuelInvoiceShared';

const BRAND = '#2563EB';

/**
 * Fleet dashboard “Fuel Invoice Trend” line chart.
 * @param {{ data: Array<{ label: string, cost: number, invoiceCount?: number }>, loading?: boolean, subtitle?: string, emptyMessage?: string }} props
 */
export default function FuelInvoiceTrendChart({
  data = [],
  loading = false,
  subtitle = 'Monthly fuel invoice totals',
  emptyMessage = 'No fuel invoice amounts yet. Add invoices in the table below.'
}) {
  const fuelYMax = Math.max(...data.map((d) => d.cost), 0);
  const fuelYTick =
    fuelYMax >= 1_000_000
      ? (v) => `${(v / 1_000_000).toFixed(1)}M`
      : fuelYMax >= 1_000
        ? (v) => `${(v / 1_000).toFixed(0)}k`
        : (v) => String(v);

  return (
    <div className="fmct-card fmct-chart-card fr-fleet-invoice-trend">
      <h3>Fuel Invoice Trend</h3>
      <p className="fmct-card-sub">{subtitle}</p>
      {loading && data.length === 0 ? (
        <p className="fmct-card-sub" style={{ padding: '2rem 0', textAlign: 'center' }}>
          Loading fuel invoices…
        </p>
      ) : data.length === 0 ? (
        <p className="fmct-card-sub" style={{ padding: '2rem 0', textAlign: 'center' }}>
          {emptyMessage}
        </p>
      ) : (
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={data} margin={{ top: 8, right: 24, left: 8, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} interval={0} angle={-25} textAnchor="end" height={56} />
            <YAxis tickFormatter={fuelYTick} tick={{ fontSize: 12 }} width={56} />
            <Tooltip
              formatter={(v) => [formatFleetFuelTSh(v) || v, 'Total']}
              labelFormatter={(label, payload) => {
                const count = payload?.[0]?.payload?.invoiceCount;
                return count != null ? `${label} · ${count} invoice(s)` : label;
              }}
            />
            <Line
              type="monotone"
              dataKey="cost"
              name="Total"
              stroke={BRAND}
              strokeWidth={3}
              dot={{ r: 4, fill: BRAND }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
